import React, { useId } from "react";

/**
 * SmartInput — input with built-in datalist suggestions.
 * Allows picking from a list OR free-typing a new value.
 * Perfect for customer / supplier name fields when master data exists.
 */
export default function SmartInput({ value, onChange, options = [], placeholder, required, testId, ...rest }) {
  const id = useId();
  return (
    <>
      <input
        list={id}
        value={value || ""}
        onChange={(e) => onChange(e.target.value)}
        required={required}
        placeholder={placeholder}
        data-testid={testId}
        autoComplete="off"
        className={`w-full border border-[#e4e4e7] bg-white px-3 py-2 text-sm focus:border-[#002FA7] focus:ring-2 focus:ring-[#002FA7]/20 outline-none ${rest.className || ""}`}
        {...rest}
      />
      <datalist id={id}>
        {options.map((o) => (
          <option key={o.value || o.label} value={o.value || o.label}>
            {o.hint || ""}
          </option>
        ))}
      </datalist>
    </>
  );
}
